module.exports = __webpack_public_path__ + "static/media/about-community-gardens-sm.1e0d8470.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/headers/about-community-gardens-sm.jpg
// module id = 152
// module chunks = 12